var _path, _path2, _path3, _g, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5999 23.2412H4.72363C4.20613 23.2412 3.78613 22.8212 3.78613 22.3037C3.78613 21.7862 4.20613 21.3662 4.72363 21.3662H12.5999C13.1174 21.3662 13.5374 21.7862 13.5374 22.3037C13.5374 22.8212 13.1174 23.2412 12.5999 23.2412Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9883 11.1255H16.1133C15.5958 11.1255 15.1758 10.7055 15.1758 10.188C15.1758 9.67049 15.5958 9.25049 16.1133 9.25049H23.9883C24.5058 9.25049 24.9258 9.67049 24.9258 10.188C24.9258 10.7055 24.5058 11.1255 23.9883 11.1255Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2287_1480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 9,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 6.25049H11.5322V13.99H3.75V6.25049Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2287_1480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64125 8.125C6.53 8.125 5.625 9.02 5.625 10.1212C5.625 11.2213 6.53 12.115 7.64125 12.115C8.75375 12.115 9.6575 11.2213 9.6575 10.1212C9.6575 9.02 8.75375 8.125 7.64125 8.125ZM7.64125 13.99C5.49625 13.99 3.75 12.255 3.75 10.1212C3.75 7.9875 5.49625 6.25 7.64125 6.25C9.7875 6.25 11.5325 7.9875 11.5325 10.1212C11.5325 12.255 9.7875 13.99 7.64125 13.99Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7343 20.2598C20.6218 20.2598 19.7168 21.1548 19.7168 22.2548C19.7168 23.356 20.6218 24.2498 21.7343 24.2498C22.8455 24.2498 23.7493 23.356 23.7493 22.2548C23.7493 21.1548 22.8455 20.2598 21.7343 20.2598ZM21.7343 26.1248C19.588 26.1248 17.8418 24.3885 17.8418 22.2548C17.8418 20.121 19.588 18.3848 21.7343 18.3848C23.8793 18.3848 25.6243 20.121 25.6243 22.2548C25.6243 24.3885 23.8793 26.1248 21.7343 26.1248Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0896ed8c4e057b0b9387209932717dbb.svg";
export { ForwardRef as ReactComponent };